import { Typography } from '@mui/material';
import HelpInfoWrapper from '../../../../help-info-wrapper';

import locales from '../../../../../../constants/commonLocales';

const SessionTypeColumnHeaderWithInfo = () => (
  <HelpInfoWrapper
    tooltip={
      <>
        <p>Ussd session can be one of:</p>
        <p>
          <b>P2A</b> (Person to Application) - session initiated by the customer dial
        </p>
        <p>
          <b>A2P</b> (Application to Person) - push session initiated by developer
        </p>
        <p>
          <b>A2A</b> (Application to Application) - session initiated by the other USSD app (e.g. session redirect)
        </p>
      </>
    }
  >
    <Typography variant="h3">{locales.table.column.session_type}</Typography>
  </HelpInfoWrapper>
);

export default SessionTypeColumnHeaderWithInfo;
